import { render, staticRenderFns } from "./UsageOverseasDataTopTenPieChart.vue?vue&type=template&id=09fc8935&scoped=true&"
import script from "./UsageOverseasDataTopTenPieChart.vue?vue&type=script&lang=js&"
export * from "./UsageOverseasDataTopTenPieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fc8935",
  null
  
)

export default component.exports